export default __webpack_public_path__ + "navigation-examples-advanced-thumbnail-960-ae4b6e027e9ca1183d905eddd5939898.webp";